import { cn } from "../utils/className";

interface AustraliaMapCardProps {
  title: string;
  subtitle: string;
  className?: string;
}

export const AustraliaMapMaskedCard = ({
  title,
  subtitle,
  className,
}: AustraliaMapCardProps) => {
  return (
    <div
      className={cn(`flex items-center absolute inset-0`, className)}
      style={{
        maskImage: "url(/images/australia-map.webp)",
        maskSize: "contain",
        maskPosition: "center",
        maskRepeat: "no-repeat",
      }}
    >
      <div className="map-card__content text-center w-full mx-auto">
        <h4 className="text-white mb-2 text-2xl lg:text-4xl xl:text-5xl">
          {title}
        </h4>
        <p className="text-white mb-10 xl:max-w-[360px] mx-auto">{subtitle}</p>
      </div>
    </div>
  );
};
